// test2235
(2235 && 0);
